<!-- ===================================
     MAPA INTERACTIVO - LA JOYA PARK RESORT
     =================================== -->

<section id="mapa" class="interactive-map-section">
  <div class="container">
    <!-- Título y descripción -->
    <div class="map-header">
      <h2>Explora nuestro Club Resort La Joya</h2>
      <p>Descubre tu futuro hogar de diversión. Explora cada zona haciendo clic en el mapa y conoce las 15 hectáreas de pura felicidad.</p>
    </div>

    <!-- Contenedor del mapa -->
    <div class="map-container">
      <!-- Imagen del mapa base -->
      <div class="map-wrapper" 
           [style.transform]="'scale(' + zoomLevel + ') translate(' + panX + 'px, ' + panY + 'px)'">
        <img [src]="getImageUrl('images/sections/map.webp')" 
             alt="Mapa interactivo La Joya Park Resort" 
             class="map-image">
        
        <!-- Marcadores interactivos -->
        <div class="map-markers">
          <div class="marker" 
               *ngFor="let marker of markers"
               [style.left]="marker.left" 
               [style.top]="marker.top"
               (click)="selectMarker(marker.id)"
               [class.active]="activeMarker === marker.id">
            <div class="marker-label" *ngIf="activeMarker !== marker.id">{{ marker.name }}</div>
            <div class="marker-icon">
              <img [src]="marker.icon" [alt]="marker.name">
            </div>
          </div>
        </div>
        
        <!-- Tooltip del marcador activo -->
        <div class="marker-tooltip" 
             *ngIf="activeMarker"
             [style.left]="getSmartTooltipPosition()?.left" 
             [style.top]="getSmartTooltipPosition()?.top"
             [style.transform]="getSmartTooltipPosition()?.transform"
             [style.margin-top]="getSmartTooltipPosition()?.marginTop"
             [class.arrow-up]="getSmartTooltipPosition()?.arrowDirection === 'up'"
             [class.arrow-left]="getSmartTooltipPosition()?.arrowDirection === 'left'"
             [class.arrow-right]="getSmartTooltipPosition()?.arrowDirection === 'right'">
          <div class="tooltip-content">
            <h4>{{ getActiveMarker()?.name }}</h4>
          </div>
          <div class="tooltip-image">
            <img [src]="getActiveMarker()?.image" [alt]="getActiveMarker()?.name">
          </div>
        </div>
      </div>

      <!-- Controles de zoom -->
      <div class="zoom-controls">
        <button class="zoom-btn zoom-in" (click)="zoomIn()" [disabled]="zoomLevel >= maxZoom">
          +
        </button>
        <button class="zoom-btn zoom-out" (click)="zoomOut()" [disabled]="zoomLevel <= minZoom">
          −
        </button>
      </div>
    </div>
  </div>
</section>
